<template>
    <div class="absolute top-0 right-0" v-if="!hideControls">
        <div class="topbar-height flex justify-end items-center pr-5">
            <div>
                <img class="w-26px" src="@/assets/header/ic-search.svg" @click="searchBarMethods.requestShow()" />
            </div>
            <div class="ml-3 relative" @click="clickCart()">
                <img class="w-26px" src="../../../../../assets/icon/ic-bag-brown.svg">
                <div v-show="CartCountStore.state.cartCount > 0"
                    class="label-cart-count bg-a-red-d62300 text-a-egg-f5ebdc text-12 absolute rounded-full">
                    {{ CartCountStore.state.cartCount }}
                </div>
            </div>
        </div>
    </div>
    <div class="flex leading-none w-full h-11 ml-4 mr-1" v-else>
        <TopBarSearch ></TopBarSearch>
    </div>
</template>
<script>
import { inject, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import Account from '@/helper/AccountHelper.js';
import TopBarSearch from './TopBarSearch.vue';
// mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
import ModalMixin from '@/mixin/ModalMixin.js';
import DeliveryMixin from '@/mixin/DeliveryMixin'
// service
import BKDeliveryMethod from "@/module/DeliveryMethod/service/BKDeliveryMethod.js";

export default {
    mixins: [AuthStatusMixin,ModalMixin,DeliveryMixin],
    inject: ['SideMenuStore', 'CartCountStore'],
    components: {
        TopBarSearch
    },
    data: function () {
        return {
            cartCount: 99,
        };
    },
    setup: function () {
        const route = useRoute()
        const { searchTerm, hideControls, searchBarMethods } = inject("SearchBarService")

        onMounted(() => {
            let q = route.query?.q ?? ""
            if (q != "") {
                searchTerm.value = q
                searchBarMethods.requestShow()
            }
        })

        return {
            hideControls,
            searchBarMethods
        }
    },
    methods: {
        clickSearch: function () {
            console.log('click search');
        },
        clickCart: function () {
            if (this.isGuestAccountRegistered || this.isLoginAccount) {
                this.getPermissionDelivery();
            } else {
                let path = this.$route.path;
                this.$router.push({
                    name: 'login',
                    query: {
                        afterLogin: path,
                    },
                });
            }
        },
        deniedPermission: function () {
            let msg_permission = "";
            if (this.delivery.deliveryMethod == 'Delivery') {
                msg_permission = this.lbl.error_delivery.delivery;
            } else {
                msg_permission = this.lbl.error_delivery.instore;
            }

            this.modal.errorModal
                        .clearModal()
                        .setMsg(msg_permission)
                        .show();
            this.modal.errorModal.onClose(()=> {
                this.CartCountStore.methods.deleteCartAll();
            })
        },
        getPermissionDelivery: async function() {
            let objPermission = await this.apiGetPermissionDelivery();
            
            if (objPermission) {
                Account.checkPermision(objPermission,this.isLoginGuest,this.delivery.deliveryMethod,()=>{
                    this.SideMenuStore.methods.openShoppingBag();
                },()=>{
                    this.deniedPermission();
                });
            }
        },
        apiGetPermissionDelivery: function() {
            return new Promise((resolve)  => {
                BKDeliveryMethod.apiGetPermissionDelivery().subscribe({
                    next: (data) => {
                        resolve(data);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(null);
                    },
                });
            });
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.topbar-height {
    height: $topbar-height;
}

.label-cart-count {
    padding: 2px 6px;
    top: -3px;
    right: -12px;
}
</style>
